var map = {
	"./conny-stage1-hungry.png": "154e",
	"./conny-stage2-hungry.png": "98bd",
	"./conny-stage3-hungry.png": "f31f",
	"./conny-stage4-hungry.png": "3d6b",
	"./conny-stage5-hungry.png": "0e21",
	"./conny-stage6-hungry.png": "5916",
	"./conny-stage7-hungry.png": "7983"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "caf4";